export const getUserNameInitials = (username: string) => {
  const splitName = username.split(' ')
  const initials = splitName.map((name) => name.charAt(0))
  return initials.join('')
}
